const INITIAL_STATE = {
    po_listing: [],
    listingMeta: null,
    listing_tbl_page: 1,

    poSearchForm: null,
    submittedPOFilterForm: null,

    formSearchedElems: [],

    searchedVendor: [],
    searchedItem: [],

    criteriaHeight: 0,
    hasLoaded: false,

    all_warehouses: [],
    all_periods: [],
    allStatusOptions: [],
    isc_configuration: null,
};

export default function poListReducer(state = INITIAL_STATE, action) {

    switch (action.type) {

        case "SET_PO_LIST_STATE":
            return {
                ...state,
                ...action.payload
            };

        case "CLEAR_PO_LIST_STATE":
            return INITIAL_STATE;

        default:
            return state;
    }
}
